export const WORKER_REQUEST_READ_LOCK = 'lock:worker:request-read';
export const WORKER_RELEASE_READ_LOCK = 'lock:worker:release-read';
export const MASTER_GRANT_READ_LOCK = 'lock:master:grant-read';
export const WORKER_REQUEST_WRITE_LOCK = 'lock:worker:request-write';
export const WORKER_RELEASE_WRITE_LOCK = 'lock:worker:release-write';
export const MASTER_GRANT_WRITE_LOCK = 'lock:master:grant-write';
//# sourceMappingURL=constants.js.map